module.exports = __webpack_public_path__ + "img/productRobot_15.127df936.png";